
import { apiHelper} from "../apiHelper/apiHelper";
import { formHelper } from "../apiHelper/formHelper";
import {
    createSchedualerRequest,
    createSchedualerSuccess,
    createSchedualerFailure,
    editSchedualerRequest,
    editSchedualerSuccess,
    editSchedualerFailure,
  getSchedualerRequest,
  getSchedualerSuccess,
  getSchedualerFailure,
  deleteSchedualerRequest,
  deleteSchedualerSuccess,
  deleteSchedualerFailure,
  deleteTaskRequest,
  deleteTaskSuccess,
  deleteTaskFailure,
} from "../slices/schedualerSlices";

// ========================== NEW API HANDLER =================

// get Crop list
export const handleGetSchedualerList = async (dispatch) => {
  const endPoint = "schedualer/allschedualers";
  const method = "GET";
  const state1 = getSchedualerRequest;
  const state2 = getSchedualerSuccess;
  const state3 = getSchedualerFailure;
  const isToast = false;
  const isFile = false;
  const isToken = true;
  return await apiHelper(
    endPoint,
    method,
    null,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};



// create Regin
export const handleCreateSchedualer = async (formData, dispatch) => {

  const endPoint = "schedualer/create";
  const method = "POST";
  const state1 = createSchedualerRequest;
  const state2 = createSchedualerSuccess;
  const state3 = createSchedualerFailure;
  const isToast = true;
  const isFile = false;
  const isToken = true;
  const body = formData;
  return await apiHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};



// edit Schedualer
export const handleEditSchedualer = async (schedualerId, formData, dispatch) => {

  const endPoint = `schedualer/editschedualer/${schedualerId}`;
  const method = "PUT";
  const state1 = editSchedualerRequest;
  const state2 = editSchedualerSuccess;
  const state3 = editSchedualerFailure;
  const isToast = true;
  const isFile = false;
  const isToken = true;
  const body = formData;
  return await apiHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};


// edit Schedualer
export const handleUpdateSchedualer = async (schedualerId, formData, dispatch) => {

  const endPoint = `schedualer/updateschedualer/${schedualerId}`;
  const method = "PUT";
  const state1 = editSchedualerRequest;
  const state2 = editSchedualerSuccess;
  const state3 = editSchedualerFailure;
  const isToast = true;
  const isFile = false;
  const isToken = true;
  const body = formData;
  return await apiHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};



// delete Schedualer
export const handleDeleteSchedualer = (schedualerId) => async (dispatch) => {
  const endPoint = `schedualer/deleteschedualer/${schedualerId}`;  // Supplier ID is appended to the endpoint
  const method = "DELETE";  // Use DELETE method to remove the supplier
  
  const state1 = deleteSchedualerRequest; // Request state action (loading)
  const state2 = deleteSchedualerSuccess; // Success state action
  const state3 = deleteSchedualerFailure; // Failure state action
  const isToast = false; // Toast disabled (can be enabled if you wish)
  const isFile = false; // No file upload involved
  const isToken = true; // Include authentication token

  // Call apiHelper, passing dispatch correctly
  await apiHelper(
    endPoint,
    method,
    null,  // No body required for DELETE
    state1,
    state2,
    state3,
    dispatch,  // Ensure dispatch is passed properly
    isFile,
    isToast,
    isToken
  );
};


// delete Schedualer
export const handleDeleteTask = (schedualerId, task_id) => async (dispatch) => {
  const endPoint = `schedualer/deletetask/${schedualerId}/${task_id}`;  // Supplier ID is appended to the endpoint
  const method = "DELETE";  // Use DELETE method to remove the supplier
  
  const state1 = deleteTaskRequest; // Request state action (loading)
  const state2 = deleteTaskSuccess; // Success state action
  const state3 = deleteTaskFailure; // Failure state action
  const isToast = false; // Toast disabled (can be enabled if you wish)
  const isFile = false; // No file upload involved
  const isToken = true; // Include authentication token
// const body = { task_id }; // Pass the task_id in the body
  // Call apiHelper, passing dispatch correctly
  await apiHelper(
    endPoint,
    method,
    null,  // No body required for DELETE
    state1,
    state2,
    state3,
    dispatch,  // Ensure dispatch is passed properly
    isFile,
    isToast,
    isToken
  );
};

export const handleAddTaskToSchedualer = (schedualerId, newTasks) => async (dispatch) => {
  const endPoint = `schedualer/${schedualerId}/tasks`;
  const method = "POST";
  const state1 = createSchedualerRequest; // You can create a new action if you want
  const state2 = createSchedualerSuccess;
  const state3 = createSchedualerFailure;
  const isToast = true;
  const isFile = false;
  const isToken = true;
  const body = newTasks;
  return apiHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};